/* eslint-disable  @typescript-eslint/no-explicit-any */
import * as React from 'react';
import {
  defineDataset,
  EDatasetColors,
  EDatasetColorTypes,
  filterTicksVarA,
  getTooltipTitleVarA,
  verticalGridLineColorCb,
  yAxisTicksCb,
  TChartFactoryProps,
  getTooltipLabelVarB,
} from '@cian/react-chartjs-component';
import { getPriceUnit } from '../../selectors/realtyValuation';
import { EChartType } from '../../types/charts';
import { IRealtyValuation } from '../../types/realtyValuation';

export const useDynamicSalesChartCfg = ({ salesDynamics }: IRealtyValuation): TChartFactoryProps | null => {
  const priceUnit = getPriceUnit(EChartType.Sales);

  return React.useMemo(() => {
    if (!salesDynamics || !salesDynamics.chart) {
      return null;
    }

    const {
      chart: { datesLabels, firstLineValues, labels, maxChartValue, minChartValue, labelStep },
    } = salesDynamics;

    const dataset = defineDataset({
      data: firstLineValues,
      color: EDatasetColors.BLUE,
      colorType: EDatasetColorTypes.SOLID,
    });

    return {
      datasetCfgCreators: [dataset],
      chartCfgParams: {
        chartType: 'bar',
        labelsData: datesLabels as string[],
        yMaxVal: maxChartValue,
        yMinVal: minChartValue,
        yValStep: labelStep,
        tooltipTitleCb: getTooltipTitleVarA,
        tooltipLabelCb: getTooltipLabelVarB(labels),
        xAfterTickToLabelConversion: filterTicksVarA,
        xGridLinesColor: verticalGridLineColorCb,
        yTicksCb: yAxisTicksCb(priceUnit),
      },
      directChartCfg: {
        options: {
          scales: {
            x: {
              gridLines: {
                display: false,
                color: 'rgba(21, 34, 66, 0.06)',
              },
            },
          },
        },
      },
      chartHeight: 264,
    };
  }, [salesDynamics, priceUnit]);
};
